import api from './api';

export type ConnectEnvironment = 'dev' | 'prod';
export type FeedbackCheckpoint = 'first' | 'second' | 'third' | 'contextual';
export type FeedbackStatus = 'rated' | 'dismissed';
export type StoreReviewAction = 'opened' | 'skipped';

export interface UserFeedbackRecord {
  responseId: string;
  userId: string;
  coupleId: string | null;
  name: string | null;
  email: string | null;
  phoneNumber: string | null;
  status: FeedbackStatus;
  rating: number | null;
  comment: string | null;
  checkpoint: FeedbackCheckpoint;
  source: string;
  platform: string | null;
  appVersion: string | null;
  storeReviewAction: StoreReviewAction | null;
  storeReviewActionAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface UserFeedbackPage {
  feedback: UserFeedbackRecord[];
  nextCursor: string | null;
}

export interface UserFeedbackFilters {
  env: ConnectEnvironment;
  limit?: number;
  cursor?: string;
  rating?: number;
  checkpoint?: FeedbackCheckpoint;
  userId?: string;
}

export async function getUserFeedback({
  env,
  limit = 50,
  cursor,
  rating,
  checkpoint,
  userId,
}: UserFeedbackFilters): Promise<UserFeedbackPage> {
  const response = await api.get('/api/connect-feedback', {
    params: {
      env,
      limit,
      ...(cursor ? { cursor } : {}),
      ...(rating ? { rating } : {}),
      ...(checkpoint ? { checkpoint } : {}),
      ...(userId?.trim() ? { userId: userId.trim() } : {}),
    },
  });
  return response.data.data;
}
